import { render, staticRenderFns } from "./ConflictOverview.vue?vue&type=template&id=18c82482&scoped=true&"
import script from "./ConflictOverview.vue?vue&type=script&lang=js&"
export * from "./ConflictOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c82482",
  null
  
)

export default component.exports